var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1123 1.9458C13.1123 1.2489 12.5421 0.678711 11.8452 0.678711H1.7085C1.0116 0.678711 0.441406 1.2489 0.441406 1.9458V9.54834C0.441406 10.2452 1.0116 10.8154 1.7085 10.8154H11.8452C12.5421 10.8154 13.1123 10.2452 13.1123 9.54834V1.9458ZM11.8452 1.9458L6.77686 5.11353L1.7085 1.9458H11.8452ZM11.8452 9.54834H1.7085V3.21289L6.77686 6.38062L11.8452 3.21289V9.54834Z",
    fill: "#FFBA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7db6dd05a2c9871d3794502269c1920e.svg";
export { ForwardRef as ReactComponent };